"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const events_1 = require("@front/components/form-parts/events");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="fixed-background"
    style="background: url(/assets/images/laptop-5673901_1280.jpg) no-repeat 50% fixed; background-size: cover;">
</div>
<main>
    <div id="firstpages-lang">
        <lang-switcher></lang-switcher>
    </div>
    <div class="container">
        <div class="h-100 row">
            <div class="mx-auto my-auto col-12 col-md-10">
                <div class="auth-card card">
                    <div class="position-relative image-side "
                        style="background:url(/assets/images/keyboard-5017973_1280.jpg); background-size: cover;">
                        <p class="text-white h2">${'login.form.hero.title'.t()}</p>
                        <p class="white mb-0">
                            ${'login.form.hero.description'.t()}
                            <br>${'login.form.hero.register_link_text'.t()}
                            <a @click="${(x, c) => x.goRegister(c.event)}" href="/register">${'login.form.hero.register_link'.t()}</a>.
                        </p>
                    </div>
                    <div class="form-side">
                        <a aria-current="page" class="active h4 mb-4 d-block" href="/">
                            ${'app.page.login_page'.t()}
                        </a>
                        <div class="mb-4 card-title">${'login.form.title'.t()}</div>
                            <the-form :onSubmit="${(x, c) => x.sendForm.bind(x)}">
                                <part-input 
                                    required="true" 
                                    name="username" 
                                    label="${'login.usernameLabel'.t()}"
                                    placeholder="${'login.username.placeholder'.t()}"
                                ></part-input>
                                <part-input 
                                    required="true" 
                                    type="password" 
                                    name="password" 
                                    label="${'login.passwordLabel'.t()}"
                                    placeholder="${'login.password.placeholder'.t()}"
                                ></part-input>
                                
                                <div class="d-flex justify-content-between align-items-center">
                                    <a @click="${(x, c) => x.goRemind(c.event)}" href="/password-reset">${'login.forgotPassword'.t()}</a>
                                    <button @click="${(x, c) => x.sendSubmit(x, c)}" class="btn-shadow btn-multiple-state  btn btn-primary btn-lg">
                                        <span class="label">${'login.submit'.t()}</span>
                                    </button>
                                </div>
                            </the-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  height: 100%;
  display: block;
}

#firstpages-lang {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1000;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 5px;
}

main {
  margin: 0 !important;
  height: 100%;
}
main .container {
  height: 100%;
}
main a {
  color: var(--primary-color);
}`;
const shadowOptions = { "mode": "open" };
let LoginPage = class LoginPage extends client_1.RWSViewComponent {
    constructor() {
        super();
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
        this.fields = {
            username: '',
            password: ''
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        this.on(events_1.inputEvents.changed, (event) => {
            this.fields[event.detail.fieldName] = event.detail.element.value;
        });
    }
    async sendForm(event) {
        var _a, _b;
        const formData = {
            username: this.fields.username,
            passwd: this.fields.password,
        };
        const serverResponse = await this.apiService.back.post('auth.login', formData);
        if (serverResponse.success && ((_a = serverResponse.data) === null || _a === void 0 ? void 0 : _a.token)) {
            this.onLogin((_b = serverResponse.data) === null || _b === void 0 ? void 0 : _b.user, serverResponse.data.token);
            this.$('the-form').reset();
        }
        else {
            this.notifyService.notify(`Login error: ${serverResponse.error}`, 'error');
        }
    }
    goRegister(event) {
        event.preventDefault();
        // SiteMenu.goto.bind(this)((event.target as HTMLAnchorElement).href);
        this.$emit('force-register', { register: true });
    }
    goRemind(event) {
        event.preventDefault();
        // SiteMenu.goto.bind(this)((event.target as HTMLAnchorElement).href);
        this.$emit('force-remind', { remind: true });
    }
    goToPasswordReset(e) {
        e.preventDefault();
        component_2.SiteMenu.goto.bind(this)('/password-reset');
    }
};
exports.LoginPage = LoginPage;
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], LoginPage.prototype, "onLogin", void 0);
exports.LoginPage = LoginPage = __decorate([
    (0, client_1.RWSView)('page-login', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __metadata("design:paramtypes", [])
], LoginPage);
LoginPage.defineComponent();
